import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadAdministradora = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      tooltip: "Código - Administradora",
      title: "Administradora",
      align: "left",
      width: "90%",
    },
    {
      title: "Ativo",
      align: "left",
      width: "100px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
